module.exports = __webpack_public_path__ + "static/media/cm-logo-white.a265df85.svg";